import React, { useState } from 'react';
import { confirmarCodigo } from '../../services/mfa';

// Tela de desafio: o admin ja logou com senha, tem MFA, e precisa digitar o
// codigo do app para subir a sessao para aal2 e liberar o painel.
const MfaChallenge = ({ factorId, onSucesso }) => {
  const [codigo, setCodigo] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  const confirmar = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setErro('');
    try {
      await confirmarCodigo(factorId, codigo.trim());
      onSucesso();
    } catch (err) {
      console.error(err);
      setErro('Código inválido ou expirado. Tente o código atual do app.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <form
        onSubmit={confirmar}
        className="w-full max-w-sm bg-white rounded-lg border border-gray-200 p-8"
      >
        <h1 className="text-xl font-bold text-gray-900 mb-2">Verificação em duas etapas</h1>
        <p className="text-sm text-gray-600 mb-6">
          Digite o código de 6 dígitos do seu app autenticador para entrar no painel.
        </p>

        <input
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          value={codigo}
          onChange={(e) => setCodigo(e.target.value.replace(/\D/g, '').slice(0, 6))}
          placeholder="000000"
          autoFocus
          className="w-full text-center tracking-[0.5em] text-lg border border-gray-300 rounded py-2 mb-4"
        />

        {erro && <p className="text-sm text-red-600 mb-4">{erro}</p>}

        <button
          type="submit"
          disabled={enviando || codigo.length !== 6}
          className="w-full py-2 rounded bg-rn-navy text-white hover:bg-rn-navy-surface disabled:opacity-40"
        >
          {enviando ? 'Verificando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
};

export default MfaChallenge;
